import firebase from "firebase/app";
import "firebase/firestore";
import { mapGetters } from "vuex";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import routerFunctions from "@/data/functions/mixins/routerFunctions.js";
import filter from "@/globals/filter/mixins/filter.js";
import getList from "@/data/cloud/firebase/mixins/getList.js";
import announcements from "@/frame/messages/mixins/announcements.js";
import statsFunctions from "@/data/functions/mixins/statsFunctions.js";
import relpsFunctions from "@/data/functions/mixins/relpsFunctions.js";
import describeDocument from "@/data/describe/mixins/describeDocument.js";
export default {
  data() {
    return {
      results: []
    };
  },
  mixins: [
    dataSources,
    storeFunctions,
    routerFunctions,
    statsFunctions,
    relpsFunctions,
    filter,
    announcements,
    describeDocument,
    getList
  ],
  computed: {
    // eslint-disable-next-line
    ...mapGetters(["getDataSource", "getUser", "getTasksListCounter"]),
  },
  methods: {
    getDocumentDirectThenPage(tag, did, page) {
      const db = this.defineDataSourceFromTag(tag);
      let detail = null;
      let routerPage = null;
      if (page === null || page === undefined || page === "") {
        routerPage = this.defineRouter(tag);
      } else {
        routerPage = page;
      }
      let t = this;
      // console.log("");
      // console.log(" >>> GET DOC DIRECT THEN PAGE <<< ");
      // console.log("TAG:   " + tag);
      // console.log("PAGE:  " + routerPage);
      // console.log("DID:   " + did);
      // console.log(db);
      // eslint-disable-next-line
      db.doc(did).get().then((doc) => {
          detail = doc.data();
          // console.log("");
          // console.log("GET STATS REMOTE");
          // GET STATS REMOTE IF AVAILABLE
          if (t.enableStatsRemote(tag)) {
            t.getDocumentStatsRemote(detail);
          }
        })
        .then(() => {
          // console.log(">>> GET REMOTE RELPS THEN PAGE");
          // console.log(detail);
          // GET RELPS
          t.getRelpsRemoteThenPageDetail(detail, routerPage);
        })
        .catch(error => {
          t.showSnackbar(error.message, "error");
        });
    },
    getArchiveDirectThenPage(tag, did, page) {
      const db = this.defineDataSourceFromTagForArchive(tag);
      let detail = null;
      let routerPage = null;
      if (page === null || page === undefined || page === "") {
        routerPage = this.defineRouter(tag);
      } else {
        routerPage = page;
      }
      let t = this;
      // console.log("");
      // console.log(" >>> GET ARCHIVE DIRECT THEN PAGE <<< ");
      // console.log("TAG:   " + tag);
      // console.log("PAGE:  " + routerPage);
      // console.log("DID:   " + did);
      // console.log(db);
      // eslint-disable-next-line
      db.doc(did).get().then((doc) => {
          detail = doc.data();
          // console.log("");
          // console.log("GET STATS REMOTE");
          // GET STATS REMOTE IF AVAILABLE
          if (t.enableStatsRemote(tag)) {
            t.getDocumentStatsRemote(detail);
          }
        })
        .then(() => {
          // console.log(">>> GET REMOTE RELPS THEN PAGE");
          // console.log(detail);
          // GET RELPS
          t.getRelpsRemoteThenPageDetail(detail, routerPage);
        })
        .catch(error => {
          t.showSnackbar(error.message, "error");
        });
    },
    getDocumentDirect(tag, did) {
      const db = this.defineDataSourceFromTag(tag);
      let t = this;
      // console.log("GET DOC DIRECT");
      // console.log(db);
      // console.log(did);
      // eslint-disable-next-line
      db.doc(did).get().then((doc) => {
          if (doc.exists) {
            t.saveToStore(doc.data());
          } else {
            // t.showSnackbar("No Data", "error");
          }
        })
        .catch(error => {
          console.log(error.message);
          // t.showSnackbar(error.message, "error");
        });
    },
    getDocumentInfoCard(tag, did) {
      const db = this.defineDataSourceFromTag(tag);
      // HELP
      // console.log("");
      // console.log(">>> GET INFO CARD <<<");
      // console.log("TAG " + tag);
      // console.log("DID " + did);
      // console.log(db);
      // eslint-disable-next-line
      // eslint-disable-next-line
      db.doc(did).get()
        // eslint-disable-next-line
        .then((doc) => {
          if (doc.exists) {
            this.$store.dispatch("changeInfoCard", doc.data());
            this.$store.dispatch("changeAdmin", doc.data());
            this.$store.dispatch("changeAdminBasic", doc.data().basic);
            this.$store.dispatch("changeDataSavePendingIndication", false);
          } else {
            // this.showSnackbar("No Data", "error");
          }
        })
        // eslint-disable-next-line
        .then((doc) => {
          // console.log(">>> STATS <<<");
          // console.log(this.getInfoCard);
          this.getDocumentStatsRemote(this.getInfoCard);
        })
        .catch(error => {
          this.showSnackbar(error.message, "error");
        });
    },
    getDocumentCompanyOnly(did) {
      let t = this;
      const db = this.defineDataSourceFromTag("C1");
      // console.log("GET DOC COMP. DIRECT");
      // console.log(db);
      // console.log(did);
      // eslint-disable-next-line
      db.doc(did).get().then((doc) => {
          if (doc.exists) {
            t.$store.dispatch("changeCompany", doc.data());
            t.$store.dispatch("changeCompanyDID", did);
            // eslint-disable-next-line
            // t.$store.dispatch("changeCompanyAccess", doc.data().pref.settings.access);
          } else {
            // t.showSnackbar("No Data", "error");
          }
        })
        .catch(error => {
          t.showSnackbar(error.message, "error");
        });
    },
    getDocumentCompanyAccessOnly(did) {
      let t = this;
      const db = this.defineDataSourceFromTag("C1");
      // console.log("GET DOC COMP. DIRECT");
      // console.log(db);
      // console.log(did);
      // eslint-disable-next-line
      db.doc(did).get().then((doc) => {
          if (doc.exists) {
            // eslint-disable-next-line
            let access = doc.data().pref.settings.access;
            let did = doc.data().basic.did;
            t.$store.dispatch("changeCompanyAccess", access);
            t.$store.dispatch("changeCompanyDID", did);
          } else {
            // t.showSnackbar("No Data", "error");
          }
        })
        .catch(error => {
          t.showSnackbar(error.message, "error");
        });
    },
    getDocumentFacilityOnly(did) {
      let t = this;
      const db = this.defineDataSourceFromTag("F1");
      // console.log("GET DOC FACILITY DIRECT");
      // console.log(db);
      // console.log(did);
      // eslint-disable-next-line
      db.doc(did).get().then((doc) => {
          if (doc.exists) {
            t.$store.dispatch("changeFacility", doc.data());
            t.$store.dispatch("changeFacilityDID", did);
          } else {
            // t.showSnackbar("No Data", "error");
          }
        })
        .catch(error => {
          t.showSnackbar(error.message, "error");
        });
    },
    getDocumentFacilityAccessOnly(did) {
      let t = this;
      const db = this.defineDataSourceFromTag("F1");
      // console.log("GET DOC FACILITY ACCESS");
      // console.log(db);
      // console.log(did);
      // eslint-disable-next-line
      db.doc(did).get().then((doc) => {
          if (doc.exists) {
            let access = doc.data().pref.settings.access;
            let did = doc.data().basic.did;
            t.$store.dispatch("changeFacilityAccess", access);
            t.$store.dispatch("changeFacilityDID", did);
          } else {
            // t.showSnackbar("No Data", "error");
          }
        })
        .catch(error => {
          t.showSnackbar(error.message, "error");
        });
    },
    getDocumentStatsRemote(detail) {
      const db = this.defineDataSourceFromTag("G5");
      let did = detail.basic.did;
      let tag = detail.basic.tag;
      let t = this;
      // console.log("GET DOC STATS - SAVE TO STORE");
      // console.log(db);
      // console.log(did);
      // eslint-disable-next-line
      db.doc(did).get().then((doc) => {
          t.$store.dispatch("changeStatsRemote", doc.data());
          if (tag === "U1") {
            t.$store.dispatch("changeUserStats", doc.data());
          }
        })
        .catch(error => {
          t.showSnackbar(error.message, "error");
        });
    },
    getDocumentStatsRemoteDirect(docdid) {
      const db = this.defineDataSourceFromTag("G5");
      let did = docdid;
      let t = this;
      // console.log("GET DOC STATS DIRECT - SAVE TO STORE");
      // console.log(db);
      // console.log(did);
      // eslint-disable-next-line
      db.doc(did).get().then((doc) => {
          t.$store.dispatch("changeDetailStats", doc.data());
        })
        .catch(error => {
          t.showSnackbar(error.message, "error");
        });
    },
    getRelpsRemoteThenPageDetail(detail, page) {
      // console.log(">>> GET REMOTE RELPS");
      // GET Relationshiop for Detail
      const db = this.defineDataSourceFromTag("G6");
      let did = detail.basic.did;
      let t = this;
      // eslint-disable-next-line
      db.doc(did).get().then((doc) => {
          // console.log(doc.data());
          // SAVE RELPS to STORE
          // console.log(">>> SAVE RELPS REMOTE TO STORE");
          t.$store.dispatch("changeRelpsRemote", doc.data());
          // SAVE DETAIL to STORE
          // console.log(">>> SAVE DATA TO STORE");
          // console.log(detail);
          t.saveToStore(detail);
          // LOAD Router
          // console.log(">>> GO TO PAGE");
          // console.log(page);
          t.$router.push(page);
        })
        .catch(error => {
          t.showSnackbar(error.message, "error");
        });
    },
    getAppendedRelpsRemoteThenStore(detail) {
      // console.log(">>> GET APPENDED DOC. REMOTE RELPS <<<");
      // GET Relationshiop for Detail
      const db = this.defineDataSourceFromTag("G6");
      let did = detail.basic.did;
      let t = this;
      // eslint-disable-next-line
      db.doc(did).get().then((doc) => {
          console.log(doc.data());
          // SAVE RELPS to STORE
          // console.log("");
          // console.log(">>> SAVE RELPS REMOTE TO STORE");
          t.$store.dispatch("changeRelpsRemoteAppended", doc.data());
          // GENERATE INFO
          let tag = detail.basic.tag;
          let msg = t.defineDocumentFromTag(tag).title;
          msg = msg + " " + detail.basic.id;
          msg = msg + " was added.";
          if (tag === "E6") {
            t.refreshResultList();
            this.generateInfoSnackbar(this.ui.btnColorGrey, msg);
          }
          if (tag === "W6") {
            t.refreshTaskList();
            this.generateInfoSnackbar(this.ui.btnColorGrey, msg);
          }
          // CLOSE WINDOW
          this.dialog = false;
        })
        .catch(error => {
          t.showSnackbar(error.message, "error");
        });
    },
    importRelpsRemoteThenStore(tag, did) {
      // console.log(">>> IMPORT REMOTE RELPS [Single RELP ONLY]<<<");
      // GET Relationshiop for Detail
      const db = this.defineDataSourceFromTag("G6");
      let t = this;
      // eslint-disable-next-line
      db.doc(did).get().then((doc) => {
          // SAVE RELPS to STORE
          // console.log("");
          // console.log(">>> SAVE RELPS REMOTE TO STORE");
          // console.log("TAG    " + tag);
          // console.log("DID    " + did);
          // console.log(doc.data());
          if (tag === "E5") {
            let list = doc.data();
            this.$store.dispatch("changeResultsList", list.e5);
            this.$store.dispatch("changeResultsListCounter", list.e5.length);
            // t.$store.dispatch("changeRelpsRemoteAppended", doc.data());
          }
          if (tag === "W5") {
            let list = doc.data();
            this.$store.dispatch("changeTasksList", list.w5);
            this.$store.dispatch("changeTasksListCounter", list.w5.length);
            // t.$store.dispatch("changeRelpsRemoteAppended", doc.data());
          }
          // t.$store.dispatch("changeRelpsRemoteAppended", doc.data());
          // GENERATE INFO
          // let tag = detail.basic.tag;
          // let msg = t.defineDocumentFromTag(tag).title;
          // msg = msg + " " + detail.basic.id;
          // msg = msg + " was added.";
          // if (tag === "E6") {
          //   t.refreshResultList();
          //   this.generateInfoSnackbar(this.ui.btnColorGrey, msg);
          // }
          // if (tag === "W6") {
          //   t.refreshTaskList();
          //   this.generateInfoSnackbar(this.ui.btnColorGrey, msg);
          // }
          // CLOSE WINDOW
          this.dialog = false;
        })
        .catch(error => {
          t.showSnackbar(error.message, "error");
        });
    },
    refreshTaskList() {
      console.log("");
      // console.log(">>> REFRESH TASKS LIST <<<");
      // eslint-disable-next-line
      console.log(this.getTasksListCounter);
      let store = "changeTasksListCounter";
      // counter +1 and -1, needed to refresh the list
      this.$store.dispatch(store, this.getTasksListCounter + 1);
      this.$store.dispatch(store, this.getTasksListCounter - 1);
    },
    refreshResultList() {
      console.log("");
      // console.log(">>> REFRESH RESULTS LIST <<<");
      // eslint-disable-next-line
      console.log(this.getResultsListCounter);
      let store = "changeResultsListCounter";
      // counter +1 and -1, needed to refresh the list
      this.$store.dispatch(store, this.getResultsListCounter + 1);
      this.$store.dispatch(store, this.getResultsListCounter - 1);
    },
    getActionDirectThenPage(action) {
      // db is defined from
      const did = action.basic.did;
      const tag = action.basic.tag;
      let cdid = action.link.cdid;
      // eslint-disable-next-line
      const db = firebase.firestore().collection("governance").doc(cdid).collection("action");
      const page = this.defineRouter(tag);
      let t = this;
      // console.log("GET ACTION DIRECT");
      // console.log(page);
      // console.log(db);
      // console.log(did);
      // eslint-disable-next-line
      db.doc(did).get().then((doc) => {
          let detail = doc.data();
          t.getRelpsRemoteThenPageDetail(detail, page);
        })
        .catch(error => {
          t.showSnackbar(error.message, "error");
        });
    },
    getDashboardThenPage(tag, did) {
      const db = this.defineDataSourceFromTag(tag);
      const page = this.defineRouter(tag);
      let t = this;
      let docdid = null;
      // console.log("GET DOC DIRECT THEN PAGE 2");
      // console.log("GET DASH THEN PAGE");
      // console.log(tag);
      // console.log(page);
      // console.log(db);
      // console.log(did);

      // for other search:
      let storeLog = this.defineStore("D3");
      let dbLog = this.defineDataSourceFromTagForRelationship("D3", tag);
      // console.log("DB LOG");
      // console.log(tag);
      let sortLog = "NewestLast";
      let orderLog = "basic.did";

      // eslint-disable-next-line
      db.doc(did).get().then((doc) => {
          t.saveToStore(doc.data());
          docdid = doc.data().basic.did;
        })
        // eslint-disable-next-line
        .then((doc) => {
          t.getListDirect(dbLog, orderLog, sortLog, storeLog, null);
        })
        // eslint-disable-next-line
        .then((doc) => {
          // console.log("STATS GO GO GO");
          // CHANGE HERE TO MAKE UPDATE
          // console.log(docdid);
          this.getDocumentStatsRemoteDirect(docdid);
        })
        // eslint-disable-next-line
        .then((doc) => {
          // console.log("ROUTER");
          // console.log(page);
          t.$router.push(page);
        })
        .catch(error => {
          t.showSnackbar(error.message, "error");
        });
    }
  }
};
